import { render, staticRenderFns } from "./companyCodePayment.vue?vue&type=template&id=72c0c387&scoped=true"
import script from "./companyCodePayment.vue?vue&type=script&lang=js"
export * from "./companyCodePayment.vue?vue&type=script&lang=js"
import style0 from "./companyCodePayment.vue?vue&type=style&index=0&id=72c0c387&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c0c387",
  null
  
)

export default component.exports